(function () {
  'use strict';

  if (window.__jpSiblingsLoaded) return;
  window.__jpSiblingsLoaded = true;

  /* ---- image preload ---- */
  function preload(url) {
    if (!url) return;
    (new window.Image()).src = url;
  }

  /* ---- init one siblings container ---- */
  function initSiblings(el) {
    var card = el.closest('.card-wrapper');
    if (!card) return;
    var img = card.querySelector('.card__inner .card__media img');
    if (!img) return;
    var track = el.querySelector('.product-card-siblings__track');
    var overflowLabel = el.querySelector('[data-sibling-overflow]');

    function updateOverflowLabel() {
      if (!track || !overflowLabel) return;
      var firstItem = track.querySelector('.product-card-siblings__item');
      if (!firstItem) return;
      var itemWidth = firstItem.getBoundingClientRect().width;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0);
      var total = Number(el.dataset.siblingCount || track.children.length);
      var visible = Math.max(1, Math.floor((track.clientWidth + gap) / (itemWidth + gap)));
      var hidden = Math.max(total - visible, 0);
      overflowLabel.hidden = hidden === 0;
      overflowLabel.textContent = hidden > 0 ? '+' + hidden + ' colores' : '';
      el.classList.toggle('is-overflowing', hidden > 0);
    }

    /* Store original src/srcset once */
    if (!img.dataset.origSrc) {
      img.dataset.origSrc = img.src;
      img.dataset.origSrcset = img.srcset || '';
    }

    /* The item that represents the current (active) product */
    var originItem = el.querySelector('.product-card-siblings__item--active');

    /* Preload all sibling images the first time the card is moused over */
    var preloaded = false;
    card.addEventListener('mouseenter', function () {
      if (preloaded) return;
      preloaded = true;
      el.querySelectorAll('.product-card-siblings__item[data-img]').forEach(function (item) {
        preload(item.dataset.img);
      });
    }, { passive: true });

    /* ---- desktop: event delegation (one listener covers all items) ---- */
    el.addEventListener('mouseover', function (e) {
      var item = e.target.closest('.product-card-siblings__item[data-img]');
      if (!item) return;

      /* Shift visual active indicator */
      el.querySelectorAll('.product-card-siblings__item--active').forEach(function (a) {
        a.classList.remove('product-card-siblings__item--active');
      });
      item.classList.add('product-card-siblings__item--active');

      /* Swap main card image */
      img.srcset = '';
      img.src = item.dataset.img;
    });

    /* Restore when mouse leaves the siblings strip */
    el.addEventListener('mouseleave', function () {
      el.querySelectorAll('.product-card-siblings__item--active').forEach(function (a) {
        a.classList.remove('product-card-siblings__item--active');
      });
      if (originItem) originItem.classList.add('product-card-siblings__item--active');

      img.srcset = img.dataset.origSrcset;
      img.src = img.dataset.origSrc;
    });

    /* ---- mobile: touchstart previews image, touchend navigates if no scroll ---- */
    var _touchItem = null;
    var _touchStartX = 0;
    var _touchStartY = 0;

    el.addEventListener('touchstart', function (e) {
      _touchItem = e.target.closest('.product-card-siblings__item[data-img]');
      if (!_touchItem) return;
      _touchStartX = e.touches[0].clientX;
      _touchStartY = e.touches[0].clientY;
      img.srcset = '';
      img.src = _touchItem.dataset.img;
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      if (!_touchItem) return;
      var dx = Math.abs(e.changedTouches[0].clientX - _touchStartX);
      var dy = Math.abs(e.changedTouches[0].clientY - _touchStartY);
      /* If it was a scroll gesture, restore image without navigating */
      if (dx > 10 || dy > 10) {
        img.srcset = img.dataset.origSrcset;
        img.src = img.dataset.origSrc;
        e.preventDefault(); /* cancel link navigation */
      }
      _touchItem = null;
    }, { passive: false });

    updateOverflowLabel();
    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(updateOverflowLabel);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', updateOverflowLabel, { passive: true });
    }
  }

  /* ---- scan document for uninitialised siblings containers ---- */
  function initAll() {
    document.querySelectorAll('.product-card-siblings:not([data-jp-si-init])').forEach(function (el) {
      el.dataset.jpSiInit = '1';
      initSiblings(el);
    });
  }

  /* ---- bootstrap ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor section reloads */
  document.addEventListener('shopify:section:load', initAll);

  /* Dynamic content: infinite scroll, Quick View, recommendation injections */
  if ('MutationObserver' in window) {
    var _mo = new MutationObserver(function (mutations) {
      var needsInit = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === Node.ELEMENT_NODE &&
            (n.matches('.product-card-siblings') || n.querySelector('.product-card-siblings'));
        });
      });
      if (needsInit) initAll();
    });
    _mo.observe(document.body, { childList: true, subtree: true });
  }
})();
